/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Loader from '../../common/Loader';
import Odd from '../../common/Odd';
import { useFetchWidgets } from '../../data/fetchWidgets';
import { getNumberOfColsMobile } from '../../data/utils/getNumberOfColsMobile';
import { iconCategoryCssClass } from '../../data/utils/iconCategoryCssClass';
import { iconSportCssClass } from '../../data/utils/iconSportCssClass';
import { PrematchContext } from '../Prematch';

function LastMinute(props) {
    const prematchContext = React.useContext(PrematchContext);
    const [data, setData] = useState(prematchContext.cache.widgets);
    const fetchData = data == null;
    const [state] = useFetchWidgets(fetchData);

    useEffect(() => {
        if (fetchData && !state.isLoading && !state.isError) {
            prematchContext.cache.widgets = state.data;
            setData(state.data);
        }
    }, [state]);

    if (!data) {
        return <Loader error={state.isError} />
    }

    return (
        <div id="last-minute-events">
            <span className="list-heading">Last Minute</span>
            {data.lastMinute && Object.keys(data.lastMinute.matchesBySport).map((k, j) =>
                <React.Fragment key={j}>
                    <div className="list-element sport-collapse">
                        <div className={`prematch-sport-img big ${iconSportCssClass(k)}`}></div>
                        <span className="list-element-text list-heading">{data.lastMinute.matchesBySport[k][0].sportDesc}</span>
                        <span className="push-right list-element-info"></span>
                    </div>
                    {data.lastMinute.matchesBySport[k].map((match, i) => {
                        const odds = match.gruppiScommessa[0].scommesse[0].odds;
                        const tData = props.data?.tournamentByUniqueId[[match.sportRef, match.categoryRef, match.tournamentRef].join('_')] ?? null;
                        const iconClass = tData?.iconClass ?? null;
                        const icoCategory = iconCategoryCssClass(match.sportRef, match.categoryRef, iconClass);
                        return (
                            <React.Fragment key={i}>
                                <div className="heading text-medium cg-flex">                                    
                                    <span className="push-left push-right">{match.tournamentDesc}</span>
                                    <div className={`prematch-sport-img big ${icoCategory}`}></div>
                                </div>
                                <a className="info-avvenimento">
                                    <div className="nome-avvenimento">
                                        <span className="text-small">{match.team1}</span>
                                        <span className="text-small">{match.team2}</span>
                                    </div>
                                    <span className="ora-avvenimento text-small push-right">{match.date} - {match.time}</span>
                                </a>
                                <div className={"esiti-container grid-columns-" + getNumberOfColsMobile(odds.length)}>
                                    {odds.map(odd =>
                                        <Odd key={odd.id} {...odd} />
                                    )}
                                </div>
                            </React.Fragment>
                        );
                    })}
                </React.Fragment>
            )}
        </div>
    );
}

export default LastMinute;